export default "__VITE_ASSET__29e40294__"